import { render, staticRenderFns } from "./PanelDashboard.vue?vue&type=template&id=3b89b860&scoped=true&"
import script from "./PanelDashboard.vue?vue&type=script&lang=js&"
export * from "./PanelDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PanelDashboard.vue?vue&type=style&index=0&id=3b89b860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b89b860",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
